<form class="form-inline amount-filter">
    <div class="search-input-wrapper"></div>
    <div class="region-field-equality"></div>
    <div class="search-input-wrapper search-operand-container {{#if isOpBetween}} range-input {{/if}}">
		<label for="field-value-{{cid}}" class="sr-only">{{locale 'searchValue'}}</label>
        <div class="search-operand">
			<input type="text" id="field-value-{{cid}}" name="field-value" value="{{ value.[0] }}" data-bind="model" class="form-control">
			<span class="help-block" data-bind="model" data-validate="field-value"></span>
        </div>
        <div class="search-operand">
			<input type="text" id="field-value2-{{cid}}" name="field-value2" data-bind="model" class="form-control" value="{{ value.[1] }}" placeholder="end">
			<span class="help-block" data-bind="model" data-validate="field-value2"></span>
        </div>
		<button type="button" class="close" data-control="removeFilter">{{icon name="close" locale="clearFilter"}}</button>
    </div>
    <button type="submit" name="submit" class="btn btn-sm btn-primary" disabled>{{locale 'apply'}}</button>
    <button type="button" name="clear" class="btn btn-sm btn-tertiary btn-clear-filter hidden">{{locale "clear"}}</button>
</form>
